import { IntegrationsMarketplaceGridAvailableNirvanaDataProvider } from '../dataProvider/IntegrationsMarketplaceGridAvailableNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class IntegrationsMarketplaceGridAvailableDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrationsMarketplaceGridAvailableNirvanaDataProvider);
  }
}
